/**
 * L'intention qui survit à la connexion.
 *
 * `pendingAction` vit dans un état React. Il suffit pour une connexion par mot
 * de passe, qui se joue dans la modale sans quitter la page. Il ne survit PAS
 * au lien magique : celui-ci ouvre une route de vérification, toute
 * l'application se remonte, et l'état est perdu. Mesuré sur un compte réel —
 * fiche composée, clic sur Enregistrer, connexion par lien magique, retour au
 * générateur, et AUCUNE fiche créée.
 *
 * La redirection, elle, traverse déjà : elle est rangée dans `sessionStorage`
 * (`postLoginRedirect`). On range l'intention au même endroit, pour la même
 * raison. L'asymétrie entre les deux était le défaut.
 *
 * Ce module rassemble ce mécanisme, jusqu'ici écrit dans l'atelier : les deux
 * parcours en ont besoin et il ne doit exister qu'une fois.
 */
const CLE_ACTION_APRES_CONNEXION = "lemaitremot_action_apres_connexion";

export function noterActionApresConnexion(action) {
  try {
    sessionStorage.setItem(CLE_ACTION_APRES_CONNEXION, action);
  } catch (e) { /* navigation privée : sans mémoire, on ne reprend pas */ }
}

/**
 * Reprend l'intention, UNE SEULE FOIS.
 *
 * L'usage unique n'est pas un détail : deux chemins de reprise peuvent s'armer
 * pour la même connexion (l'évènement de la modale et l'effet de session).
 * Celui qui consomme l'intention agit, l'autre ne trouve rien et se tait —
 * sans quoi un clic produirait deux fiches.
 */
export function reprendreActionApresConnexion() {
  try {
    const action = sessionStorage.getItem(CLE_ACTION_APRES_CONNEXION);
    if (action) sessionStorage.removeItem(CLE_ACTION_APRES_CONNEXION);
    return action;
  } catch (e) {
    return null;
  }
}

export { CLE_ACTION_APRES_CONNEXION };
